/**
 * Публичный флоу резидента: ключ со скоупом `resident:booking` умеет только
 * найти счёт по телефону и создать бронь от его имени — обычную бронь этим
 * ключом сделать нельзя, поэтому его можно держать в бандле.
 */

import { request } from '../api'
import type { ScheduleResponse } from '../panel/lib/api'

const API_KEY = (import.meta.env.VITE_RESIDENT_API_KEY as string | undefined) || ''
/** Куда уходит нерезидент — обычная страница бронирования. */
export const PUBLIC_BOOKING_URL =
  (import.meta.env.VITE_PUBLIC_BOOKING_URL as string | undefined) ||
  'https://peregovorki.com'

export type { ScheduleResponse, ScheduleRoom } from '../panel/lib/api'
export { getLocations } from '../api'

export interface ResidentLookup {
  accountName: string
  tariff: string
  locationId: number | null
  remainingMinutes: number | null
  freeHoursExhausted: boolean
}

export interface ResidentBookingResult {
  id: number
  startTime: string
  endTime: string
  freeHoursExhausted: boolean
  room?: { name: string }
}

export const lookupResident = (phone: string) =>
  request<ResidentLookup>(
    `/external/residents/lookup?phone=${encodeURIComponent(phone)}`,
    undefined,
    { apiKey: API_KEY },
  )

/** С ключом видны и private-комнаты локации (их и бронируют резиденты);
 *  чужие брони при этом приходят без имён — бэк маскирует. */
export const getSchedule = (locationId: number, date: string) =>
  request<ScheduleResponse>(
    `/external/schedule?locationId=${locationId}&date=${date}`,
    undefined,
    { apiKey: API_KEY, unwrap: false },
  )

export const bookAsResident = (payload: {
  roomId: number
  residentPhone: string
  startTime: string
  endTime: string
}) =>
  request<ResidentBookingResult>(
    '/external/bookings',
    // Источник — в примечание брони, как делают витрины: админ видит, откуда она.
    { method: 'POST', body: JSON.stringify({ ...payload, description: 'Страница резидента' }) },
    { apiKey: API_KEY },
  )
